import {
  cleanErrors,
  createApplication,
  fetchApplication,
  updateApplication,
} from '../actions/applicationsActions'

export default function currentApplicationReducer(state = { item: null, fetching: false }, action) {
  switch (action.type) {
    case updateApplication.pending.type:
      return { ...state, updating: true }

    case fetchApplication.fulfilled.type:
      return {
        ...state,
        fetching: false,
        item: action.payload,
      }
    case fetchApplication.rejected.type:
      return { ...state, fetching: false }

    case fetchApplication.pending.type:
    case createApplication.pending.type:
      return { ...state, fetching: true, errors: [] }

    case updateApplication.fulfilled.type: {
      return { ...state, updating: false, errors: [], item: action.payload }
    }

    case createApplication.rejected.type:
    case updateApplication.rejected.type: {
      if (action.payload?.field === 'config_errors') {
        const configErrors = action.payload.error_data?.configErrors || []
        const errors = configErrors
          .sort((a, b) => {
            if (a.path === b.path) {
              return 0
            }
            return a.path > b.path ? 1 : -1
          })
          .reduce((acc, cur) => {
            const last = acc[acc.length - 1]
            if (last && last.value === cur.value && last.path === cur.path) {
              last.message += ` ${cur.message}`
              return acc
            }
            acc.push({ ...cur })
            return acc
          }, [])

        return {
          ...state,
          updating: false,
          fetching: false,
          errors,
        }
      }

      return { ...state, updating: false, fetching: false, errors: [] }
    }
    case cleanErrors.type:
      return { ...state, errors: [] }
  }

  return state
}
